import backendUrls from '@/utility/backendUrls';

export default {
  methods: {
    serveBackendFileUrl(fileUrl) {
      return backendUrls.serveBackendUrl(fileUrl, this.$store.getters);
    },
    underscoreToHyphen(str) {
      if (str === null || str === undefined) return null;
      return String(str).replace(/_/g, '-');
    },
    camelToKebabCase(str) {
      if (str === null || str === undefined) return null;
      return String(str).replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    },
    setFavicon(rawPath) {
      const favicon = document.getElementById('favicon');
      if (!favicon) return;
      favicon.href = rawPath ? this.serveBackendFileUrl(rawPath) : '/favicon.ico';
    },
  },
};
